import { gql, useQuery } from '@apollo/client';
import { lobbyGameFragment } from 'graphql/fragments';
import { useEffect } from 'react';

import {
  GameDifficulty,
  ActiveGamesByDifficultyAndScene,
  ActiveGamesByDifficultyAndSceneVariables,
} from 'graphql/types';

import GameTable from '../UnfinishedGames/GameList/GameTable';

interface SceneDetailModalTabPanelUnfinishedProps {
  isVisible: boolean;
  sceneId: string;
  gameDifficulty: GameDifficulty;
}
const SceneDetailModalTabPanelUnfinished = ({
  isVisible,
  sceneId,
  gameDifficulty,
}: SceneDetailModalTabPanelUnfinishedProps) => {
  const activeGamesByDifficultyAndSceneQuery = gql`
    query ActiveGamesByDifficultyAndScene(
      $gameDifficulty: GameDifficulty!
      $sceneId: Int!
    ) {
      activeGamesByDifficultyAndScene(
        gameDifficulty: $gameDifficulty
        sceneId: $sceneId
      ) {
        ...LobbyGame
      }
    }
    ${lobbyGameFragment}
  `;

  // NOTE: We dont want to load qgl data, when modal has been closed, sceneId = undefined
  const { data, refetch } = useQuery<
    ActiveGamesByDifficultyAndScene,
    ActiveGamesByDifficultyAndSceneVariables
  >(activeGamesByDifficultyAndSceneQuery, {
    // fetchPolicy: 'cache-and-network', // it makes infinity re-rendering, so used refetch()
    variables: {
      sceneId: Number.parseInt(sceneId),
      gameDifficulty,
    },
    skip: !sceneId,
  });

  useEffect(() => {
    if (isVisible) {
      refetch();
    }
  }, [isVisible, refetch]);

  return (
    <GameTable
      css={{ margin: 0 }}
      isSelectedScene
      games={data?.activeGamesByDifficultyAndScene || []}
    />
  );
};

export default SceneDetailModalTabPanelUnfinished;
